import { zodResolver } from '@hookform/resolvers/zod'
import { Stack } from '@mui/material'
import FormInput from 'components/form-elements/FormInput'
import { useCharactersLeft } from 'hooks/useCharactersLeft'
import { ChangeEvent } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { object, string, TypeOf } from 'zod'

export const ARTICLE_NOTE_MAX_LENGTH = 2000

export const isArticleNoteTooLong = (note: string) => note.length > ARTICLE_NOTE_MAX_LENGTH

export function ArticleNote({
  note,
  onChange,
}: {
  note: string
  onChange: (note: string) => void
}) {
  const formSchema = object({
    note: string().max(
      ARTICLE_NOTE_MAX_LENGTH,
      `Please enter a maximum of ${ARTICLE_NOTE_MAX_LENGTH} characters`,
    ),
  })

  type FormType = TypeOf<typeof formSchema>

  const methods = useForm<FormType>({
    mode: 'onChange' as const,
    resolver: zodResolver(formSchema),
    defaultValues: {
      note,
    },
  })

  // the counter must follow the field itself, not the copy of the value kept by the parent
  const noteValue = methods.watch('note')
  const charactersLeft = useCharactersLeft(ARTICLE_NOTE_MAX_LENGTH, noteValue?.length ?? 0)

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    onChange(e.target.value)
  }

  return (
    <Stack sx={{ width: '100%', maxWidth: 800 }}>
      <FormProvider {...methods}>
        <FormInput
          label="Internal Note"
          name="note"
          fullWidth
          minRows={3}
          maxRows={6}
          multiline
          placeholder="Start typing"
          onChange={handleChange}
          helperText={charactersLeft}
          checkTouchField={false}
        />
      </FormProvider>
    </Stack>
  )
}
